var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Row',[_c('Col',{attrs:{"cols":"12 col-sm-8"}},[_c('Table',{staticClass:"ml-3",attrs:{"headers":_vm.headers,"items":_vm.items,"hide-default-footer":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }